import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchWalkThroughDone = (_, { payload }) => {
  return [
    ...payload,
  ]
};

const setwalkthroughReviewStatus = (state, { payload}) => {
  return state.map(wt => {
    if(wt.suiteId === payload.suiteId && wt.id === payload.id) {
      return payload
    } else {
      return wt
    }
  })
}

const saveWalkthrough = (state, { payload }) => {
  return [...state, payload];
}

const deleteWalkthroughDone = (state, {payload}) => {
  return state.filter(wt => wt.id !== payload);
}

const clearWalkthroughDone = () => {
  return initialState;
}
const initialState = [];

export default createReducer(initialState, {
    [TYPES.FETCH_WALK_THROUGHS_DONE]:fetchWalkThroughDone,
    [TYPES.SET_WALKTHROUGH_REVIEW_STATUS]: setwalkthroughReviewStatus,
    [TYPES.SAVE_WALKTHROUGH]: saveWalkthrough,
    [TYPES.DELETE_WALKTHROUGH_DONE]: deleteWalkthroughDone,
    [TYPES.CLEAR_WALKTHROUGH_DONE]: clearWalkthroughDone
});
